import { gql, useMutation } from "@apollo/client";
import { cartVar } from "./useCart";

export type CustomerInputType = {
	code: string,
}

export type IndustryInputType = {
	code: string,
}

type ShippingOrderInputType = {
	code: string,
	paymentTerm?: string | null,
}

type RefCartInputType = {
	externalId: string,
	refId: string,
}

type SurplusProductInputType = {
	code: string,
	amount: number,
	commercialPolicyId: number,
	price?: number,
	discount: number,
}


export type CartSurplusInput = {
	customer: CustomerInputType,
	industry: IndustryInputType
	shippingOrder: ShippingOrderInputType[]
	ref: RefCartInputType
	itens: SurplusProductInputType[]
}

const CREATE_CART = gql`
  mutation CreateCartSurplusItens($input: Cart_CartSurplusInput!) {
    Cart_createCartSurplusItens(input: $input) {
      id
        customerCode
        industryCode
        status
        code
        userId
				grossPrice
				netPrice
				valid
				discountValue
				coupons
				shippingOrders {
					code
					paymentTerm
				}
				items {
					code
					amount
					totalDiscount
					commercialPolicyId
					type
					valid
					unitGrossPrice
					unitNetPrice
					grossPrice
					netPrice
					discountValue
					discount
					errors {
						type
						message
					}
					discountsTrace
					coupons {
						name
						percentage
					}
          product {
						code
						description
						brand {
							id
							description
						}
						assortment {
							name
						}
					}
					suggestions{
						list{
							name
							code
							amount
						}
						anchor {
							anchorAmount
						}
					}
				}
    }
  }
`;

export const useCreateCartSurplus = () => {
	return useMutation(CREATE_CART, {
		refetchQueries: [
			'Cart'
		],
		onCompleted(data) {
			if (data.Cart_createCartSurplusItens) {
				cartVar(data.Cart_createCartSurplusItens)
			}
		},
	});
};